import { createApiCall } from "services/api/createApiCall";
import { transformErrorResponse } from "services/api/transformation";
import { PublicApiCreatedKey, PublicApiKeyFormValues, PublicApiSettings } from "./types";
import {
  transformPublicApiCreatedKey,
  transformPublicApiKeyOnCreate,
  transformPublicApiSettings,
} from "./transformation";

const PUBLIC_API_PATH = "/v1/settings/public-api";

const errorMessage = (error: any) => `${transformErrorResponse(error)}`;

/*---------------------------------------------------------------------------------------
  JAVNI API - POSTAVKE (opt-in + popis ključeva)
-----------------------------------------------------------------------------------------*/
export const getPublicApiSettingsAPI = async (): Promise<PublicApiSettings> => {
  const response = await createApiCall(
    { path: PUBLIC_API_PATH, method: "GET" },
    { getMessage: { error: errorMessage } }
  )();

  return transformPublicApiSettings(response.data);
};

export const updatePublicApiSettingsAPI = async (enabled: boolean): Promise<PublicApiSettings> => {
  const response = await createApiCall(
    { path: PUBLIC_API_PATH, method: "PUT", body: { enabled } },
    {
      getMessage: {
        success: () => (enabled ? "Javni API je uključen." : "Javni API je isključen."),
        error: errorMessage,
      },
    }
  )();

  return transformPublicApiSettings(response.data);
};

/*---------------------------------------------------------------------------------------
  JAVNI API - KLJUČEVI
-----------------------------------------------------------------------------------------*/

/** Izdaje ključ. Odgovor je jedini put da se ključ vidi u cijelosti. */
export const createPublicApiKeyAPI = async (
  formValues: PublicApiKeyFormValues
): Promise<PublicApiCreatedKey> => {
  const response = await createApiCall(
    {
      path: `${PUBLIC_API_PATH}/keys`,
      method: "POST",
      body: transformPublicApiKeyOnCreate(formValues),
    },
    {
      getMessage: {
        success: () => "Izdan je novi API ključ.",
        error: errorMessage,
      },
    }
  )();

  return transformPublicApiCreatedKey(response.data);
};

/** Opoziv je trajan — za ponovni pristup izdaje se novi ključ. */
export const revokePublicApiKeyAPI = async (keyId: string): Promise<boolean> => {
  const response = await createApiCall(
    { path: `${PUBLIC_API_PATH}/keys/${keyId}`, method: "DELETE" },
    {
      getMessage: {
        success: () => "API ključ je opozvan.",
        error: errorMessage,
      },
    }
  )();

  return !!response.data;
};
